import React from "react";

interface ConversationIconProps {
  size?: number;
  fill?: string;
}

const ConversationIcon: React.FC<ConversationIconProps> = ({
  size = 24,
  fill,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={fill ? fill : "none"}
    >
      <g clipPath="url(#clip0_8567_216681)">
        <path
          d="M17.5 9.16536C17.5 8.94435 17.4122 8.73245 17.2559 8.57617C17.0996 8.41989 16.8877 8.33203 16.6667 8.33203H15C14.5398 8.33203 14.1667 7.95894 14.1667 7.4987C14.1667 7.03846 14.5398 6.66536 15 6.66536H16.6667C17.3297 6.66536 17.9654 6.92895 18.4343 7.39779C18.9031 7.86663 19.1667 8.50232 19.1667 9.16536V18.332C19.1667 18.669 18.9637 18.9729 18.6524 19.1019C18.341 19.2309 17.9825 19.1596 17.7442 18.9212L14.655 15.832H10C9.33697 15.832 8.70127 15.5684 8.23243 15.0996C7.76359 14.6308 7.50001 13.9951 7.50001 13.332V12.4987C7.50001 12.0385 7.87311 11.6654 8.33334 11.6654C8.79358 11.6654 9.16668 12.0385 9.16668 12.4987V13.332C9.16668 13.553 9.25454 13.7649 9.41082 13.9212C9.5671 14.0775 9.779 14.1654 10 14.1654H15C15.221 14.1654 15.4329 14.2532 15.5892 14.4095L17.5 16.3203V9.16536ZM10.8333 3.33203C10.8333 3.11102 10.7455 2.89912 10.5892 2.74284C10.4329 2.58656 10.221 2.4987 10 2.4987H3.33334C2.87691 2.4987 2.50001 2.8756 2.50001 3.33203V10.487L4.41082 8.57617L4.47185 8.52083C4.62015 8.3993 4.8066 8.33203 5.00001 8.33203H10C10.221 8.33203 10.4329 8.24417 10.5892 8.08789C10.7455 7.93161 10.8333 7.71971 10.8333 7.4987V3.33203ZM12.5 7.4987C12.5 8.16174 12.2364 8.79744 11.7676 9.26628C11.2987 9.73512 10.6631 9.9987 10 9.9987H5.34506L2.25587 13.0879C2.01754 13.3262 1.65906 13.3975 1.34767 13.2686C1.03633 13.1395 0.833344 12.8357 0.833344 12.4987V3.33203C0.833344 1.95513 1.95644 0.832031 3.33334 0.832031H10C10.6631 0.832031 11.2987 1.09561 11.7676 1.56445C12.2364 2.03329 12.5 2.66899 12.5 3.33203V7.4987Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_8567_216681">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ConversationIcon;
